<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="
            border-radius: 5px !important;
            padding-left: 0px;
            height: auto !important;
          "
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Email List</b-navbar-brand>
          <b-navbar-nav class="ml-auto">
              <b-button
                :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
                class="ml-3"
                @click="getAllEmailDataMasterList('Excel')"
                size="sm"
                variant="outline-info"
                >{{ ExcelBtnName }}
                <b-spinner
                  v-if="ExcelBtnName != 'Export As Excel'"
                  small
                  label="Small Spinner"
                ></b-spinner
              ></b-button>
          </b-navbar-nav>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <!-- Add Update Form Input End-->
            <b-card class="gutr" v-if="addEditCard">
              <b-row class="justify-content-left">
                <b-col md="12">
                  <h5>Email List Details</h5>
                </b-col>
                <b-col md="12">
                  <label>Email Name</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="email_name"
                    name="email_name"
                    disabled
                    v-model="EmailListMaster.email_name"
                    placeholder="Email Name"
                  ></b-form-input>
                </b-col>
                <b-col md="4">
                  <label>Email TO <span class="error">*</span></label>
                  <b-textarea
                    id="emaillist_to"
                    name="emaillist_to"
                    v-model="EmailListMaster.emaillist_to"
                    placeholder="Email TO"
                    @input="checkEmailID('emaillist_to')"
                  ></b-textarea>
                  <span class="error" v-if="!EmailListMaster.emaillist_to || errorList.emaillist_to">{{ errorList.emaillist_to }}</span>
                </b-col>
                <b-col md="4">
                  <label>Email CC</label>
                  <b-textarea
                    :formatter="capitalizeAll"
                    id="emaillist_cc"
                    name="emaillist_cc"
                    v-model="EmailListMaster.emaillist_cc"
                    placeholder="Email CC"
                    @input="checkEmailID('emaillist_cc')"
                  ></b-textarea>
                  <span class="error" v-if="errorList.emaillist_cc">{{ errorList.emaillist_cc }}</span>
                </b-col>
                <b-col md="4">
                  <label>Email BCC</label>
                  <b-textarea
                    :formatter="capitalizeAll"
                    id="emaillist_bcc"
                    name="emaillist_bcc"
                    v-model="EmailListMaster.emaillist_bcc"
                    placeholder="Email BCC"
                    @input="checkEmailID('emaillist_bcc')"
                  ></b-textarea>
                  <span class="error" v-if="errorList.emaillist_bcc">{{ errorList.emaillist_bcc }}</span>
                </b-col>
                <b-col md="12">
                  <label>Select Branches</label>
                  <multi-select
                    :options="branchListOptions"
                    :selected-options="branch_items"
                    v-model="selectedBranches"
                    placeholder="Select Branches"
                    :multiple="true"
                    @select="SelectMultiBranch"
                  ></multi-select>
                  <span v-if="branchListOptions.length === 0" class="text-muted">
                    <small>No branches available</small>
                  </span>
                </b-col>
                <b-col md="12" v-if="branch_items && branch_items.length > 0" class="mt-3">
                  <h6>Branch Email Configuration</h6>
                  <div class="table-responsive tableMain mt-2">
                    <table class="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th>Branch Name</th>
                          <th>Email TO</th>
                          <th>Email CC</th>
                          <th>Email BCC</th>
                          <th>Export</th>
                          <th>Import</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in branchEmailTableData" :key="index">
                          <td>
                            <span>{{ item.branch_name }}</span>
                          </td>
                          <td>
                            <b-textarea
                              v-model="item.emails_to"
                              placeholder="Email TO"
                              rows="2"
                              @input="validateBranchEmail(item, 'emails_to')"
                            ></b-textarea>
                            <span class="error" v-if="item.errors && item.errors.emails_to">{{ item.errors.emails_to }}</span>
                          </td>
                          <td>
                            <b-textarea
                              v-model="item.emails_cc"
                              placeholder="Email CC"
                              rows="2"
                              @input="validateBranchEmail(item, 'emails_cc')"
                            ></b-textarea>
                            <span class="error" v-if="item.errors && item.errors.emails_cc">{{ item.errors.emails_cc }}</span>
                          </td>
                          <td>
                            <b-textarea
                              v-model="item.emails_bcc"
                              placeholder="Email BCC"
                              rows="2"
                              @input="validateBranchEmail(item, 'emails_bcc')"
                            ></b-textarea>
                            <span class="error" v-if="item.errors && item.errors.emails_bcc">{{ item.errors.emails_bcc }}</span>
                          </td>
                          <td>
                            <b-form-checkbox v-model="item.is_export" :value="1" :unchecked-value="0">
                              Export
                            </b-form-checkbox>
                          </td>
                          <td>
                            <b-form-checkbox v-model="item.is_import" :value="1" :unchecked-value="0">
                              Import
                            </b-form-checkbox>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-col>
                <b-col md="12">
                  <center>
                    <b-button
                      style="margin-bottom: 0.3rem"
                      variant="success"
                      @click="addEmailListMaster"
                      class="mt-2"
                      id="addButtonLoader"
                    >Update</b-button>
                  </center>
                  <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
                </b-col>
              </b-row>
            </b-card>
            <!-- Add Update Form Input End-->

            <div class="mt-3">
              <!-- Search Form Input Start-->
              <b-row>
                <b-col md="10" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input
                        :formatter="capitalizeAll"
                        @input="debounceSearch"
                        v-model="filter"
                        placeholder="Type to Search Module Master"
                        ref="search"
                      />
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filterClear">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="2"><h5><small v-if="isLoading == false">{{ totalRows }} Entries</small></h5></b-col>
              </b-row>
              <!-- Search Form Input End-->
              <!-- Select All Checkbox -->
              <b-row class="mb-2">
                <b-col md="10">
                  <input
                    type="checkbox"
                    @change="SelectAll"
                    v-model="isCheckAll"
                  />
                  <label class="ml-2">Select / Deselect All Count ({{ selectedEmailIds.length }})</label>
                </b-col>
              </b-row>
              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table
                  show-empty
                  stacked="md"
                  :items="All_Email_List_data"
                  responsive
                  :fields="Columns"
                  primary-key="id_email_section"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  @filtered="onFiltered"
                  class="position-relative"
                >
                  <template slot="id_email_section" slot-scope="row0">
                    <input
                      type="checkbox"
                      v-bind:value="row0.item.id_email_section"
                      v-bind:id="'email_' + row0.item.id_email_section"
                      v-model="selectedEmailIds"
                      @change="updateSelectAll($event, row0.item)"
                    />
                    <span class="ml-2">
                      {{ row0.index + 1 + (currentPage - 1) * perPage }}
                    </span>
                  </template>
                  <template slot="email_name" slot-scope="row1">
                    <span>{{
                      row1.item.email_name != "" ? row1.item.email_name : "--"
                    }}</span>
                  </template>
                  <template slot="emaillist_to" slot-scope="row2">
                    <span v-if="row2.item.emaillist_to && row2.item.emaillist_to !== ''">
                      <template v-for="(item1, index) in row2.item.emaillist_to.split(',')">
                        <h6 v-if="item1.trim() !== ''">
                          <b-badge variant="light">{{ item1 }}</b-badge>
                        </h6>
                      </template>
                    </span>
                  </template>
                  <template slot="emaillist_cc" slot-scope="row3">
                    <span v-if="row3.item.emaillist_cc && row3.item.emaillist_cc !== ''">
                      <template v-for="(item2, index) in row3.item.emaillist_cc.split(',')">
                        <h6 v-if="item2.trim() !== ''">
                          <b-badge variant="light">{{ item2 }}</b-badge>
                        </h6>
                      </template>
                    </span>
                  </template>
                  <template slot="emaillist_bcc" slot-scope="row4">
                    <span v-if="row4.item.emaillist_bcc && row4.item.emaillist_bcc !== ''">
                      <template v-for="(item3, index) in row4.item.emaillist_bcc.split(',')">
                        <h6 v-if="item3.trim() !== ''">
                          <b-badge variant="light">{{ item3 }}</b-badge>
                        </h6>
                      </template>
                    </span>
                  </template>

                  <template slot="is_active_email" slot-scope="row5">
                    <div v-if="adminToggle == 'Admin'" :id="'row' + row5.item.id_email_section">
                      <md-switch
                        :id="'approval' + row5.item.id_email_section"
                        name="approval"
                        class="md-primary"
                        :value="row5.item.is_active_email == 1 ? true : false"
                        @change="activateEmailSection(row5.item)"
                      >
                        <h6>
                          <br/>
                          <b-badge style="margin-left: -45px">{{
                            row5.item.is_active_email == 1 ? "Active" : "In-Active"
                          }}</b-badge>
                        </h6>
                      </md-switch>
                    </div>
                    <div v-else :id="'row' + row5.item.id_email_section">
                      <h6>
                        <b-badge>{{
                          row5.item.is_active_email == 1 ? "Active" : "In-Active"
                        }}</b-badge>
                      </h6>
                    </div>
                  </template>
                  
                  <template slot="username" slot-scope="row22">
                    <div v-if="row22.item.username != null || row22.item.updation_time != null">
                      <span><b>Update By: </b>{{row22.item.username}}</span>
                      <br>
                      <span><b>Updation Time: </b>{{row22.item.updation_time}}</span>
                    </div>
                  </template>
                  <template slot="action" slot-scope="row5">
                    <b-button
                      variant="outline-primary"
                      @click="editEmailListDashborad(row5.item)"
                      id="addButtonLoader"
                      size="sm"
                    >Update</b-button>
                  </template>
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination
                    limit="5"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-0 pull-right"
                  />
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>  
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect, MultiSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import ClientUserService from "../../services/ClientUserService.js";
import CommonService from "../../services/CommonService.js";
export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/EmailSection");
      if (globalPermissionStatus("Dashboard_Access")) {
        this.getAllEmailDataMasterList('Normal');
        // Load branch list from store
        this.$store.dispatch(
          "common/setAllBranchList",
          JSON.stringify({
            filter: "BranchList",
            active: "all",
          })
        );
        this.loadBranchOptions();
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  data() {
    return {
      ExcelBtnName: "Export As Excel",
      addEditCard: false,
      isLoading: false,
      selectDateFormat,
      Columns: [
        {
          key: "id_email_section",
          label: "SN",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "email_name",
          label: "Email Subject",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "emaillist_to",
          label: "Email TO",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "emaillist_cc",
          label: "Email CC",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "emaillist_bcc",
          label: "Email BCC",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "username",
          label: "Email Update",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "is_active_email",
          label: "Status",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "action",
          label: "Action",
          sortable: true,
          sortDirection: "desc",
        }
      ],
      docURL: URL_BASE_DOC,
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      sortBy: null,
      sortDesc: false,
      pageOptions: [5, 10, 15],
      adminToggle: this.$sessionsStorage.get(),
      sortDirection: "desc",
      filter: null,
      changePageFilter: "0",
      modalInfo: { title: "", content: "" },
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      EmailListMaster: {
        id_email_section: "",
        email_name: "",
        emaillist_to: "",
        emaillist_cc: "",
        emaillist_bcc: "",
        is_active_email: true,
        TypeofAdd: "Email List Add"
      },
      EmailListMasterError: [
        "Please Enter Email TO",
      ],
      errorList: {
        emaillist_to: "",
        emaillist_cc: "",
        emaillist_bcc: "",
      },
      EmailDataList: [],
      All_Email_List_data: [],
      validate: true,
      visible: false,

      indexNew: "",
      deleteId: "",
      itemObj: {},
      adminToggle: this.$sessionsStorage.get("designation"),
      // Multiple selection properties
      isCheckAll: false,
      selectedEmailIds: [],
      filteredItems: [],
      // Branch selection properties
      selectedBranches: [],
      branch_items: [],
      branchOptions: [],
      branchEmailTableData: [],
      branchEmailColumns: [
        {
          key: "branch_name",
          label: "Branch Name",
          sortable: false,
        },
        {
          key: "emails_to",
          label: "Email TO",
          sortable: false,
        },
        {
          key: "emails_cc",
          label: "Email CC",
          sortable: false,
        },
        {
          key: "emails_bcc",
          label: "Email BCC",
          sortable: false,
        },
        {
          key: "is_export",
          label: "Export",
          sortable: false,
        },
        {
          key: "is_import",
          label: "Import",
          sortable: false,
        },
      ],
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    MultiSelect,
    ClientUserService,
    CommonService,
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.Columns.filter((f) => f.sortable).map((f) => {
        return { text: f.label, value: f.key };
      });
    },
    branchListOptions() {
      // Get branch list from store and ensure it's formatted correctly
      const branches = this.$store.getters['common/getAllBranchList'] || [];
      return branches.map(branch => {
        return Object.assign({}, branch, {
          value: branch.pickupId,
          text: branch.pickupLocation
        });
      });
    },
  },
  methods: {
    validateEmailList() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
          if (
          this.EmailListMaster[x] == "" ||
          this.EmailListMaster[x] == undefined ||
          this.EmailListMaster[x] == null
          ) {
              console.log("this.EmailListMaster[x]=>",this.EmailListMaster[x],x);
              console.log("this.EmailListMaster[x]=>",this.EmailListMaster);
          this.errorList[x] = this.EmailListMasterError[index];
          validate_new = false;
          }
      });
      if (validate_new != true) {
          this.validate = false;
          return;
      } else {
          this.validate = true;
      }
    },
    
    checkEmailID(column) {
      this.validateEmails(column);
    },
    validateEmails(column) {
      //alert(column)
      console.log("column => ", column);
      let validate2 = true;
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const columnValue = this.EmailListMaster[column] || '';
      console.log("columnValue => ", columnValue);
      const emails = columnValue.split(',').map(email => email.trim());
      console.log("emails => ", emails);
      // var emailsID = "SS@EONPOINTE.IO";
      // if (!emailRegex.test(emailsID)) {
      //   this.validate = false;
      // }

      for (var i=0;i<emails.length;i++) {
        console.log('1',emails[i]);
        if (!emailRegex.test(emails[i])) {
          console.log('2');
          this.errorList[column] = "Invalid email address(es)";
          console.log("this.errorList[column] => ", this.errorList[column]);
          this.validate = false;
          break; 
        }
      }
      return this.validate;
    },
    async addEmailListMaster(){
      this.validateEmailList();
      console.log("validateEmailList => ", this.validate);
  
      Object.keys(this.EmailListMaster).map((x) => {
        // alert(x)
        if (x == "emaillist_to" || x == "emaillist_cc" || x == "emaillist_bcc") {
          //alert(x);
          var val = this.checkEmailID(x);
        }
      });
      
      // Validate branch emails
      let branchValidationPassed = true;
      if (this.branchEmailTableData.length > 0) {
        for (let i = 0; i < this.branchEmailTableData.length; i++) {
          const branchItem = this.branchEmailTableData[i];
          if (branchItem.emails_to) {
            if (!this.validateBranchEmail(branchItem, 'emails_to')) {
              branchValidationPassed = false;
            }
          }
          if (branchItem.emails_cc) {
            if (!this.validateBranchEmail(branchItem, 'emails_cc')) {
              branchValidationPassed = false;
            }
          }
          if (branchItem.emails_bcc) {
            if (!this.validateBranchEmail(branchItem, 'emails_bcc')) {
              branchValidationPassed = false;
            }
          }
        }
      }
      
      if (!branchValidationPassed) {
        this.alert.content = "Please fix email validation errors in branch configuration";
        this.$refs["addPop"].open();
        return false;
      }
      
      console.log("checkEmailID => ", this.validate);
      this.EmailListMaster.TypeofAdd = "Email List Add";
      if (this.validate == false) return false;
      this.isLoading = true;

      let payload = {
          itemCode: "add_Email_List_Details",
          EmailListMaster: this.EmailListMaster,
          BranchEmailMapper: this.branchEmailTableData
      };
      payload = JSON.stringify(payload);
      if (this.validate != false) {
          CommonService.getAllCommonMaster(payload)
          .then(response => {
              const { data, status, statusText } = response;
              if (data.id_email_section != "" && data.id_email_section != undefined) {
                if (data.find == 1 || data.find == 2) {
                    this.alert.content = data.MSG;
                } else {
                    this.alert.content = data.MSG;
                }
                this.EmailListMaster = "";
        this.selectedBranches = "";
        this.branch_items = [];
        this.branchEmailTableData = [];
                this.getAllEmailDataMasterList('Normal');
                this.addEditCard = false;
              } else {
                this.alert.content = data.MSG;
              }
              this.isLoading = false;
              this.$refs["addPop"].open();
          })
          .catch(error => {
              console.log("Catch on Proforma Error: ", error);
              this.isLoading = false;
          });
      }
    },
    getAllEmailDataMasterList(type) {
      this.isLoading = true;
      if(type == "Excel"){
        this.ExcelBtnName = "Downloading Please Wait...";
      }
      let payload = {
        itemCode: "getAllEmailList",
        type: type,
      };
      console.log("Shreshth Gahlot Payload => ", payload);
      //ClientUserService.getAllOverseaLock(payload)
      CommonService.getAllCommonMaster(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log("Shreshth Gahlot Data => ", data);
          if (status == 200 && data) {
            console.log("Shreshth Gahlot Data After Success => ", data);
            if (type == "Excel") {
              this.ExcelBtnName = "Export As Excel";
              if (data.All_Email_List_data.length > 0) {
                this.All_Email_List_data = data.All_Email_List_data;
                this.totalRows = data.All_Email_List_data.length;
              }
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.All_Email_List_data.length > 0) {
                this.All_Email_List_data = data.All_Email_List_data;
                this.totalRows = data.All_Email_List_data.length;
                // Initialize filteredItems with all data
                this.filteredItems = data.All_Email_List_data;
                console.log(" All_Email_List response=>", data);
              }
            }
          } else {
            this.All_Email_List_data = [];
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on All_Email_List Error: ", error);
        });
    },
    previousSalesView() {
      window.history.go(-1);
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getAllEmailDataMasterList('Normal');
      }, 1000);
    },
    editEmailListDashborad(item) {
      console.log("Edit item:", item);
      this.addEditCard = true;
      item.TypeofAdd = "Email List Add";
      this.EmailListMaster = item;
      this.selectedBranches = "";
      this.branch_items = [];
      this.branchEmailTableData = [];
      
      // Check if BranchEmailMapper data is already in the item
      if (item.BranchEmailMapper && item.BranchEmailMapper.length > 0) {
        console.log("BranchEmailMapper found in item:", item.BranchEmailMapper);
        this.populateBranchEmailData(item.BranchEmailMapper);
      } else {
        // If not present, fetch from API
        this.getBranchEmailSectionMapper(item.id_email_section);
      }
    },
    populateBranchEmailData(branchEmailMapperData) {
      // Clear existing data
      this.selectedBranches = "";
      this.branch_items = [];
      this.branchEmailTableData = [];
      
      // Ensure branch options are loaded
      if (!this.branchListOptions || this.branchListOptions.length === 0) {
        this.loadBranchOptions();
      }
      
      branchEmailMapperData.forEach(mapper => {
        // Find branch from options
        const branch = this.branchListOptions.find(b => {
          const branchId = b.pickupId || b.value;
          return branchId == mapper.fk_branch_id;
        });
        
        if (branch) {
          // Add to branch_items for multi-select component
          this.branch_items.push({
            value: branch.pickupId || branch.value,
            text: mapper.branch_name || branch.pickupLocation || branch.text
          });
          
          this.branchEmailTableData.push({
            fk_branch_id: mapper.fk_branch_id,
            branch_name: mapper.branch_name || branch.pickupLocation || branch.text,
            emails_to: mapper.emails_to || "",
            emails_cc: mapper.emails_cc || "",
            emails_bcc: mapper.emails_bcc || "",
            is_export: parseInt(mapper.is_export) || 0,
            is_import: parseInt(mapper.is_import) || 0,
            besm_id: mapper.besm_id,
            errors: {}
          });
        } else {
          // Branch not found in options, but still add to table with available data
          console.warn("Branch not found in options:", mapper.fk_branch_id);
          this.branchEmailTableData.push({
            fk_branch_id: mapper.fk_branch_id,
            branch_name: mapper.branch_name || "Unknown Branch",
            emails_to: mapper.emails_to || "",
            emails_cc: mapper.emails_cc || "",
            emails_bcc: mapper.emails_bcc || "",
            is_export: parseInt(mapper.is_export) || 0,
            is_import: parseInt(mapper.is_import) || 0,
            besm_id: mapper.besm_id,
            errors: {}
          });
        }
      });
      
      // Update selectedBranches model value
      if (this.branch_items.length > 0) {
        this.selectedBranches = this.branch_items.map(item => item.value).join(',');
      }
      
      console.log("Populated branch_items:", this.branch_items);
      console.log("Populated branchEmailTableData:", this.branchEmailTableData);
    },
    loadBranchOptions() {
      // Load branch list from store - ensure it's loaded
      const branchList = this.$store.getters['common/getAllBranchList'] || [];
      console.log("Branch options in store:", branchList.length);
      
      // If branch options are empty, dispatch action to load them
      if (branchList.length === 0) {
        this.$store.dispatch(
          "common/setAllBranchList",
          JSON.stringify({
            filter: "BranchList",
            active: "all",
          })
        ).then(() => {
          console.log("Branch options after dispatch:", this.$store.getters['common/getAllBranchList'].length);
        }).catch(error => {
          console.error("Error loading branch list:", error);
        });
      } else {
        // Transform branch options to have value and text properties if needed
        this.branchOptions = branchList.map(branch => {
          return Object.assign({}, branch, {
            value: branch.pickupId,
            text: branch.pickupLocation
          });
        });
        console.log("Branch options transformed:", this.branchOptions.length);
      }
    },
    SelectMultiBranch(branch_items, lastSelectItem) {
      this.branch_items = branch_items;
      console.log("branch_items=>", this.branch_items);
      
      // Update table data based on selected branches
      const currentBranchIds = this.branchEmailTableData.map(item => item.fk_branch_id);
      
      // Remove branches that are no longer selected
      if (this.branch_items && this.branch_items.length > 0) {
        const selectedBranchIds = this.branch_items.map(item => item.value || item.pickupId);
        this.branchEmailTableData = this.branchEmailTableData.filter(
          item => selectedBranchIds.includes(item.fk_branch_id)
        );
        
        // Add new branches that are selected but not in table
        this.branch_items.forEach(branchItem => {
          const branchId = branchItem.value || branchItem.pickupId;
          if (!currentBranchIds.includes(branchId)) {
            this.branchEmailTableData.push({
              fk_branch_id: branchId,
              branch_name: branchItem.text || branchItem.pickupLocation,
              emails_to: "",
              emails_cc: "",
              emails_bcc: "",
              is_export: 0,
              is_import: 0,
              besm_id: null, // Will be set if editing existing record
              errors: {}
            });
          }
        });
      } else {
        // Clear table if no branches selected
        this.branchEmailTableData = [];
      }
    },
    validateBranchEmail(item, field) {
      if (!item.errors) {
        item.errors = {};
      }
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const fieldValue = item[field] || '';
      
      if (fieldValue && fieldValue.trim() !== '') {
        const emails = fieldValue.split(',').map(email => email.trim()).filter(email => email !== '');
        for (let i = 0; i < emails.length; i++) {
          if (!emailRegex.test(emails[i])) {
            item.errors[field] = "Invalid email address(es)";
            return false;
          }
        }
      }
      item.errors[field] = "";
      return true;
    },
    async getBranchEmailSectionMapper(emailSectionId) {
      if (!emailSectionId) return;
      
      this.isLoading = true;
      let payload = {
        itemCode: "getBranchEmailSectionMapper",
        fk_email_section_id: emailSectionId,
      };
      payload = JSON.stringify(payload);
      
      try {
        const response = await CommonService.getAllCommonMaster(payload);
        const { data, status } = response;
        if (status == 200 && data && data.branchEmailMapperData) {
          this.populateBranchEmailData(data.branchEmailMapperData);
        }
        this.isLoading = false;
      } catch (error) {
        console.log("Error fetching branch email mapper: ", error);
        this.isLoading = false;
      }
    },
    activateEmailListStaus(item, type) {
      let FieldVal = '';
      let TableField = '';
      if(type == "Active"){
        FieldVal = item.is_active_email == 1 ? 0 : 1;
        TableField = "is_active_email";
      } 
      let payload = {
          tableName: "email_section",
          tableId: "id_email_section",
          tableIsActive: TableField,
          value1: FieldVal,
          tableVal: item.id_email_section,
          isMailSend:'No',
          manual:'No',
      };
      //console.log("Payload => ", payload); return false;
      ClientUserService.getAllActive(JSON.stringify(payload))
      .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.getAllEmailUserList("Normal");
          }
      })
      .catch((error) => {
          console.log("Catch on getAllActive Error: ", error);
      });
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getAllEmailDataMasterList('Normal');
      }, 1000);
    },
    filterClear() {
      this.filter = "";
      this.getAllEmailDataMasterList('Normal');
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
      // Store filtered items for SelectAll functionality
      this.filteredItems = filteredItems;
      // Reset select all state when filter changes
      this.isCheckAll = false;
    },

    activateEmailSection(item, index) {
      // $("#approval" + id).val();

      this.itemObj = item;
      this.indexNew = index;

      this.deleteId = item.id_email_section;

      this.itemObj.is_active_email = this.itemObj.is_active_email == 1 ? 0 : 1;
      let paylod = {
        tableName: "email_section",
        tableId: "id_email_section",
        tableIsActive: "is_active_email",
        value1: this.itemObj.is_active_email,
        tableVal: this.deleteId,
        type: "updateStatus",
        secondKey: "updation_time",
        secondVal: "",
        isMailSend:'No',
        manual:'No',
      };

      
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/activateUser.php`,
        data: JSON.stringify(paylod),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          console.log("Salil Result => ", result);
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.getAllEmailDataMasterList('Normal');
          }
        })
        .catch((error) => {});

      // this.alert.content = true
      //   ? "Are you sure you want to Activate this User?"
      //   : "Are you sure you want to Deactivate this User?";
      // this.$refs["addPop6"].open();
    },
    SelectAll: function () {
      // Get items to select/deselect (filtered items if filter is active, otherwise all items)
      const itemsToToggle = this.filteredItems.length > 0 ? this.filteredItems : this.All_Email_List_data;
      
      if (this.isCheckAll) {
        // Select all items from current dataset
        itemsToToggle.forEach(item => {
          if (!this.selectedEmailIds.includes(item.id_email_section)) {
            this.selectedEmailIds.push(item.id_email_section);
          }
        });
      } else {
        // Deselect all items from current dataset
        itemsToToggle.forEach(item => {
          const index = this.selectedEmailIds.indexOf(item.id_email_section);
          if (index > -1) {
            this.selectedEmailIds.splice(index, 1);
          }
        });
      }
    },
    updateSelectAll: function (e, item) {
      const isSelected = this.selectedEmailIds.includes(item.id_email_section);
      
      if (!isSelected) {
        // Item was just selected
        this.selectedEmailIds.push(item.id_email_section);
      } else {
        // Item was just deselected
        const index = this.selectedEmailIds.indexOf(item.id_email_section);
        if (index > -1) {
          this.selectedEmailIds.splice(index, 1);
        }
      }
      
      // Check if all filtered items (or all items if no filter) are selected
      const itemsToCheck = this.filteredItems.length > 0 ? this.filteredItems : this.All_Email_List_data;
      const allSelected = itemsToCheck.length > 0 && itemsToCheck.every(item => 
        this.selectedEmailIds.includes(item.id_email_section)
      );
      this.isCheckAll = allSelected;
    }
  },
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// email-section.vue?4ffcba54